import React from "react";
import { RestrictedPage } from "~/router";
import {
  useNewProjectChargeEditor,
  ProjectChargeEditorProvider,
} from "./ChargeEditorProvider";
import { Route, Routes } from "react-router-dom";
import { ProjectChargesPage } from ".";
import { ChargeEditorOutlet } from "~/project-charge-form/ChargeEditorOutlet";
import { projectChargeEditChildPath } from "~/routes";

const ProjectChargesPageRoutes: React.FC = () => {
  const newProjectChargeEditor = useNewProjectChargeEditor();
  return (
    <Routes>
      <Route path="/" element={<ProjectChargesPage />}>
        <Route
          path={projectChargeEditChildPath}
          element={
            <RestrictedPage auth={newProjectChargeEditor}>
              <ChargeEditorOutlet />
            </RestrictedPage>
          }
        />
      </Route>
    </Routes>
  );
};

export const ProjectChargesPageRouter: React.FC = () => {
  return (
    <ProjectChargeEditorProvider>
      <ProjectChargesPageRoutes />
    </ProjectChargeEditorProvider>
  );
};
